<template>
  <div v-html="year.turn_in_overview_text"></div>
</template>
<script setup lang="ts">
import { ITeamCriteriaDTO, IYearDTO } from '@/dtos';
import { useSubmissionnStore } from '@/stores';

import { computed, watch } from 'vue';
interface Props {
  registration: ITeamCriteriaDTO;
  year: IYearDTO;
}
const props = defineProps<Props>();
const year = computed(() => props.year);
const registration = computed(() => props.registration);
const submissionStore = useSubmissionnStore();
watch(
  registration,
  async (newVal) => {
    if (newVal) {
      if (!newVal.submissions || newVal.submissions.length === 0) {
        await submissionStore.create.mutateAsync();
        return;
      }
    }
  },
  { immediate: true },
);
</script>
